import { render, staticRenderFns } from "./DiscussFloatPop.vue?vue&type=template&id=9c52c93a&"
import script from "./DiscussFloatPop.vue?vue&type=script&lang=js&"
export * from "./DiscussFloatPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports